<template>
  <div class="questionnaire__substrate-wrap">
    <BgIcon class="questionnaire__substrate-bg -left-" />
    <BgIcon class="questionnaire__substrate-bg -right-" />
    <div class="questionnaire__substrate">
      <slot name="header" />
      <slot />
      <Component
        :is="iconComponent"
        v-if="iconComponent"
        class="questionnaire__substrate-img"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BgIcon from './BgIcon';

import Call from './iconList/Call';
import GirlMac from './iconList/GirlMac';
import GirlVR from './iconList/GirlVr';
import GitlJump from './iconList/GitlJump';
import Hello from './iconList/Hello';
import ManMac from './iconList/ManMac';
import ManSelect from './iconList/ManSelect';
import Phone from './iconList/Phone';
import Social from './iconList/Social';

export default {
  components: {
    BgIcon,

    Call,
    GirlMac,
    GirlVR,
    GitlJump,
    Hello,
    ManMac,
    ManSelect,
    Phone,
    Social
  },
  computed: {
    ...mapState('questionnaire', {
      activeQuestionId: s => s.data.activeQuestionId
    }),
    ...mapGetters('questionnaire', {
      question: 'activeQuestion'
    }),
    iconComponent() {
      if (!this.question) {
        return false;
      }
      switch (this.question.slug) {
      case 'business':
        return 'Hello';
      case 'target':
      case 'target_course':
        return 'GirlVR';
      case 'expert':
      case 'where_expert':
      case 'niche':
        return 'Phone';
      case 'blog':
        return 'Social';
      case 'sales_experience':
      case 'business_sphere':
        return 'Call';
      case 'business_time':
        return 'ManSelect';
      case 'month_revenue':
        return 'GirlMac';
      case 'month_revenue_profit':
        return 'GirlMac';
      case 'month_revenue_profit_help':
        return 'ManMac';
      case 'month_profit':
        return 'ManMac';
      case 'leader':
      case 'want_leader':
        return 'GitlJump';
      default:
        // Если мы на странице бота
        if (this.activeQuestionId === null) {
          return 'Hello';
        }
        return false;
      }
    }
  }
};
</script>
